import { StrictMode } from 'react'
import store from './app/store'
import {Provider} from 'react-redux'
import { createRoot} from 'react-dom/client'
import App from './App.jsx'

// import ErrorBoundary from './ErrorBoundary.jsx'
import { ErrorBoundary } from "react-error-boundary";
import ErrorPage from './components/UI/ErrorPage.jsx'

createRoot(document.getElementById('root')).render(
  <Provider store ={store}>

    <ErrorBoundary fallback={<ErrorPage/>}>
    <App />
    </ErrorBoundary>

  </Provider>,
)
